.vstack {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-04);
}

.vstack.sm {
  gap: var(--spacing-02);
}

.vstack.lg {
  gap: var(--spacing-06);
}

.vstack.xl {
  gap: var(--spacing-08);
}

.vstack.xxl {
  gap: var(--spacing-10);
}
